import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import RechazoReconocimiento from "./RechazoReconocimiento";
import styles from "./styles";
import withPrograma from "js/hoc/withPrograma";
import { withRouter } from "react-router-dom";
import { graphql, withApollo } from "react-apollo";
import ReconocimientoGraphQL from "js/graphql/resolvers/reconocimiento.resolver";
import UserQraphQL from "js/graphql/resolvers/usuario.resolver";
import { formValueSelector, reduxForm } from "redux-form";
import connect from "react-redux/es/connect/connect";
const selector = formValueSelector("rechazarReconocimientoForm");

const enhance = compose(
  withPrograma,
  withRouter,
  withApollo,
  graphql(UserQraphQL.queries.getMiUsuarioCompleto, {
    options: () => ({
      fetchPolicy: "cache-first"
    }),
    props: ({ data }) => {
      const { loading, miUsuario } = data;
      if (loading) return;
      return {
        usuario: miUsuario
      };
    }
  }),
  graphql(ReconocimientoGraphQL.queries.getReconocimientoById, {
    options: ({
      computedMatch: {
        params: { idReconocimiento }
      }
    }) => ({
      fetchPolicy: "network-only",
      variables: {
        _id: idReconocimiento
      }
    }),
    props: ({ data }) => {
      const { loading, getReconocimiento } = data;
      if (loading) return;
      return {
        reconocimiento: getReconocimiento
      };
    }
  }),
  withStyles(styles),
  connect(state => selector(state, "motivo")),
  reduxForm({
    form: "rechazarReconocimientoForm",
    keepDirtyOnReinitialize: false,
    enableReinitialize: true
  })
);

export default enhance(RechazoReconocimiento);
